<template>
    <div class="coursesContact-form">
        <form v-on:submit.prevent="onSubmit">
            <input type="email" placeholder="Vložte váš e-mail…" class="email" v-model="email">
            <!--<textarea class="message" v-model="message" placeholder="Chcete se na nšco zeptat?"/>-->
            <button type="submit" class="button view-primary-light">
                {{processing ? 'Odesílám...' : 'Informujte mě'}}
            </button>
        </form>
        <div v-if="errors.length">
            <div class="error-message" v-for="error in errors">{{error.message}}</div>
        </div>
        <div v-if="success">
            Skvělé, dáme vám vědět o všech změnách
        </div>
    </div>
</template>

<script>
    import {watchDog} from './api/course';
    import filter from 'lodash/filter';
    import {isEmail} from '../../helpers/validation';

    function initialState() {
        return {
            processing: false,
            email:      '',
            message:    null,
            errors:     [],
            success:    false,
        }
    }

    export default {
        name:    'SsvWatchDog',
        data() {
            return initialState()
        },
        methods: {
            onSubmit() {
                if (false == this.validate('input')) {
                    this.processing = true;
                    watchDog(this.prepareData())
                    .then(() => {
                        this.reset();
                        this.successForm();
                    })
                    .catch(() => this.errors.push({
                        message: 'Formulář se nepodařilo odeslat, zkuste to znovu',
                        type:    'request'
                    }))
                    .finally(() => this.processing = false)
                }
            },
            validate(type) {
                this.errors = [];
                if (!isEmail(this.email)) {
                    this.errors.push({ message: 'E-mail není ve správném tvaru', type: 'input' });
                }
                return filter(this.errors, error => error.type === type).length;
            },
            reset() {
                Object.assign(this.$data, this.$options.data.apply(this));
            },
            successForm() {
                this.success = true;
                setTimeout(() => this.success = false, 10000);
            },
            prepareData() {
                return {
                    email:      this.email,
//                    message:    this.message,
                    courseSlug: this.$route.params.slug,
                };
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/ssv/WatchDog.vue